import { HTTPResponse, IPaginationResponse } from '@/services/http/http.types.ts'
import http, { handleHttpError, handleHttpResponse } from '@/services/http'
import { IOrganization, TCreateOrganizationDTO, TMaintenanceStats } from '@/pages/Organizations/organizations.types.ts'
import { IUser } from '../Users/users.types'

const list = async (params: { page?: string }): Promise<HTTPResponse<IPaginationResponse<IOrganization>>> => {
  return http.get('/nsi/v1/organizations', { params }).then(handleHttpResponse).catch(handleHttpError)
}

const getMaintenanceStats = async (
  id: IOrganization['id'],
  params: { date_gte: string; date_lte: string; userId?: IUser['id'] }
): Promise<HTTPResponse<TMaintenanceStats>> => {
  return http
    .get(`/nsi/v1/organizations/${id}/maintenance-stats`, { params })
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const getOne = async (id: IOrganization['id']): Promise<HTTPResponse<IOrganization>> => {
  return http
    .get('/nsi/v1/organizations/' + id)
    .then(handleHttpResponse)
    .catch(handleHttpError)
}

const create = async (dto: TCreateOrganizationDTO): Promise<HTTPResponse<IOrganization>> => {
  return http.post('/nsi/v1/organizations', dto).then(handleHttpResponse).catch(handleHttpError)
}

const update = async (
  id: IOrganization['id'],
  updates: Partial<IOrganization>
): Promise<HTTPResponse<IOrganization>> => {
  return http.patch(`/nsi/v1/organizations/${id}`, updates).then(handleHttpResponse).catch(handleHttpError)
}

const remove = async (id: IOrganization['id']): Promise<HTTPResponse<IOrganization>> => {
  return http.delete(`/nsi/v1/organizations/${id}`).then(handleHttpResponse).catch(handleHttpError)
}

type TOrganizationImageUploadResponse = { id: string; fileName: string; dataType: string }

const uploadImage = async (
  id: IOrganization['id'],
  file: File
): Promise<HTTPResponse<TOrganizationImageUploadResponse>> => {
  const formData = new FormData()
  formData.append('file', file)

  return http.put(`/nsi/v1/organizations/${id}/image`, formData).then(handleHttpResponse).catch(handleHttpError)
}

const organizationsApi = { list, getOne, create, update, remove, getMaintenanceStats, uploadImage }

export default organizationsApi
